import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-logo',
	imports: [NgClass, RouterLink],
	templateUrl: './logo.html',
	styleUrl: './logo.css',
})
export class Logo {
	// 'light' for white text on dark backgrounds, 'dark' for dark text on light backgrounds
	@Input() variant: 'light' | 'dark' = 'dark';
	// Size variants: 'xs', 'sm', 'md', 'lg', 'xl'
	@Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
	// Optional link behavior
	@Input() isLink: boolean = true;
	// Custom classes for additional styling
	@Input() customClass: string = '';
	// Show/hide shadow
	@Input() showShadow: boolean = true;

	get logoClasses() {
		const shadowClass = this.showShadow
			? (this.variant === 'light' ? 'drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]' : 'drop-shadow-sm')
			: '';
		const baseClass = this.variant === 'light'
			? `text-mist ${shadowClass}`
			: `text-primary ${shadowClass}`;
		return baseClass;
	}

	get subtitleClasses() {
		const shadowClass = this.showShadow
			? (this.variant === 'light' ? 'drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)]' : 'drop-shadow-sm')
			: '';
		const baseClass = this.variant === 'light'
			? `text-mist/90 ${shadowClass}`
			: `text-primary ${shadowClass}`;
		return baseClass;
	}

	get sizeClasses() {
		switch (this.size) {
			case 'xs':
				return { logo: 'text-3xl', subtitle: 'text-[8px]' };
			case 'sm':
				return { logo: 'text-5xl', subtitle: 'text-[10px]' };
			case 'md':
				return { logo: 'text-6xl lg:text-7xl', subtitle: 'text-xs lg:text-sm' };
			case 'lg':
				return { logo: 'text-7xl', subtitle: 'text-sm' };
			case 'xl':
				return { logo: 'text-8xl', subtitle: 'text-base' };
			default:
				return { logo: 'text-6xl lg:text-7xl', subtitle: 'text-xs lg:text-sm' };
		}
	}
}
